import { TierItem } from "../pages/components/tierList";

export const boardGameList: TierItem[] = [
    // S Tier
    { name: "PatchWork", tier: "S" },
    { name: "Sushi Go", tier: "S" },
    { name: "Monkiers", tier: "S" },
    { name: "Codenames", tier: "S" },
    { name: "Disney's Villinous", tier: "S" },
    { name: "Farshore", tier: "S" },
    { name: "Finspan", tier: "S" },
    { name: "Everdell", tier: "S" },
    { name: "Fromage", tier: "S" },

    // A Tier
    { name: "Jaipur", tier: "A" },
    { name: "Architects of Amytis", tier: "A" },
    { name: "Wingspan", tier: "A" },
    { name: "Walnut Grove", tier: "A" },
    { name: "Settlers of Catan", tier: "A" },
    { name: "7 Wonders - Duel", tier: "A" },
    { name: "7 Wonders", tier: "A" },
    { name: "Lords of Waterdeep", tier: "A" },
    { name: "Star Relams", tier: "A" },
    { name: "Magic The Gathering", tier: "A" },
    { name: "Sagrada", tier: "A" },
    { name: "Secret Hitler", tier: "A" },
    { name: "Small World", tier: "A" },
    { name: "Dice City", tier: "A" },
    { name: "Love Letter", tier: "A" },
    { name: "King Domino", tier: "A" },
    { name: "Creature's Comforts", tier: "A" },
    { name: "Parks", tier: "A" },
    { name: "Trails", tier: "A" },
    { name: "Botanicus", tier: "A" },
    { name: "Cash and Guns", tier: "A" },
    { name: "Clash of the Cards", tier: "A" },
    { name: "Spyfall", tier: "A" },
    { name: "Two Rooms and a Boom", tier: "A" },
    { name: "Trekking", tier: "A" },
    { name: "Guess Who", tier: "A" },

    // B Tier
    { name: "Caesar!", tier: "B" },
    { name: "Ticket To Ride", tier: "B" },
    { name: "Twlight Struggle", tier: "B" },
    { name: "Dominion", tier: "B" },
    { name: "Pandemic", tier: "B" },
    { name: "Brass", tier: "B" },
    { name: "Scythe", tier: "B" },
    { name: "Agricola", tier: "B" },
    { name: "Sorry", tier: "B" },
    { name: "Dead of Winter", tier: "B" },
    { name: "Tiny Towns", tier: "B" },
    { name: "Smash Up", tier: "B" },
    { name: "Chess", tier: "B" },
    { name: "Camel Up", tier: "B" },
    { name: "King Of Tokyo", tier: "B" },
    { name: "Kings Forge", tier: "B" },
    { name: "First Ascent", tier: "B" },
    { name: "Concept", tier: "B" },
    { name: "The Chameleon", tier: "B" },
    { name: "Avalon", tier: "B" },
    { name: "Santorini", tier: "B" },
    { name: "Dixit", tier: "B" },
    { name: "Everdell Duel", tier: "B" },

    // F Tier
    { name: "Hive", tier: "F" },
    { name: "Monopoly", tier: "F" },
    { name: "Risk", tier: "F" },
    { name: "High Society", tier: "F" },
    { name: "The Resistance", tier: "F" },
    { name: "Ultimate Werewolf", tier: "F" },
];
